module.exports = "<span *ngIf=\"!isEditing\">{{field.value}}</span>\r\n<input *ngIf=\"isEditing\" type=\"text\" [(ngModel)]=\"field.value\" (change)=\"fieldUpdated.emit(field)\" class=\"form-control\" placeholder=\"Enter short text\">\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/field/short-text/short-text.component.html
// module id = ../../../../../src/app/thought-module/field/short-text/short-text.component.html
// module chunks = main